import { jsx } from 'react/jsx-runtime';
import { createContext, forwardRef, useRef, useImperativeHandle } from 'react';

const CustomScrollContext = createContext(null);
const CustomScrollContextProviderRenderFunc = ({ children }, ref) => {
    const handlersRef = useRef([]);
    const valueRef = useRef((() => {
        return {
            subscribe: (handler) => {
                handlersRef.current.push(handler);
            },
            unsubscribe: (handlerToRemove) => {
                handlersRef.current = handlersRef.current.filter((handler) => handler !== handlerToRemove);
            },
        };
    })());
    useImperativeHandle(ref, () => ({
        notify: ({ scrollTop = 0, scrollLeft = 0, maxScrollTop = 0, maxScrollLeft = 0 }) => {
            handlersRef.current.forEach((handler) => handler({ scrollTop, scrollLeft, maxScrollTop, maxScrollLeft }));
        },
    }), []);
    return jsx(CustomScrollContext.Provider, { value: valueRef.current, children: children });
};
const CustomScrollContextProvider = forwardRef(CustomScrollContextProviderRenderFunc);

export { CustomScrollContext, CustomScrollContextProvider };
//# sourceMappingURL=context.js.map
